import { useMemo } from 'react';
import { FieldDiaryPage, toFieldDiaryFarm } from '@practium/features/field-diary';
import { useGetProperties } from '@practium/features/api';
import { useAuth } from '@practium/features/auth';

const PROPERTIES_LIMIT = 200;

export const FieldDiaryPageAdmin = () => {
	const { user } = useAuth();
	const { data: properties, isLoading } = useGetProperties({ limit: PROPERTIES_LIMIT });

	const farms = useMemo(
		() =>
			properties.map((property) =>
				toFieldDiaryFarm(
					property,
					property.userId && property.userId !== user?._id ? property.userId : undefined
				)
			),
		[properties, user?._id]
	);

	return <FieldDiaryPage farms={farms} farmsLoading={isLoading} />;
};
